document.addEventListener("DOMContentLoaded", function () {
    // Open/close main mobile menu
    document.querySelector(".mobile-menu-ttl").addEventListener("click", function () {
        this.classList.toggle("is-active");
        document.querySelector(".mobile-main-menu").classList.toggle("active");
    });

    // Handle submenu toggle for all menu levels
    document.querySelectorAll(".mobile-menu-itm-div, .mobile-secmenu-itm-div").forEach(function (menuItem) {
        menuItem.addEventListener("click", function (event) {
            let submenu = menuItem.nextElementSibling; // Find the next UL element

            if (submenu && submenu.tagName === "UL") {
                event.preventDefault(); // Prevents page reload
                
                // Toggle submenu visibility without closing other menus
                submenu.classList.toggle("active");
                menuItem.classList.toggle("is-active");
            }
        });
    });

    // Prevent clicking on links with submenus from redirecting
    document.querySelectorAll(".mobile-mnu-tll").forEach(function (link) {
        link.addEventListener("click", function (event) {
            let parentDiv = link.closest("div");
            let submenu = parentDiv.nextElementSibling;

            if (submenu && submenu.tagName === "UL") {
                event.preventDefault(); // Prevent redirect
                submenu.classList.toggle("active");
                parentDiv.classList.toggle("is-active");
            }
        });
    });
});



